// eslint-disable-next-line
import React, { useContext, useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { css } from '@emotion/react';
import {
  Text,
  Box,
  Flex,
  Link,
  theme,
  Spinner,
  Toast,
} from '@xometry/xometry_loft';
// import InfoPanel from './InfoPanel';
import CreditTermsForm from './CreditTermsForm';
import AuthContext from '@xometry/auth-context';
import { useLazyQuery } from '@apollo/client';
import { UserByIdQuery } from '../../../schema/generated/schema';

const accountsettings_page = css`
  margin: 80px 8%;
  color: rgb(60, 60, 60);

  @media (max-width: 640px) {
    margin: 80px 16px;
  }
`;

const staff_banner = css`
  margin-bottom: 40px;
  box-shadow: none;
  width: 100%;
`;

const CreditTermsApplication = () => {
  const { user, isLoading, isStaff } = useContext(AuthContext);
  const [userID, setUserID] = useState('');
  const [billingAccount, setBillingAccount] = useState();
  const params = useParams();

  useEffect(() => {
    if (!isLoading && user) {
      setUserID(params.userid || user.id);
    }
  }, [isLoading]);

  // Grab selected billing account data passed in via react-router
  const location = useLocation();

  useEffect(() => {
    // Redirect if billing account data wasn't passed in
    if (!location.state || !location.state.billingAccount) {
      if (isStaff()) {
        return window.location.assign(
          `/user-settings/${userID}?msg=User must have an active Billing Profile to submit a credit application.&type=warning`
        );
      } else {
        return window.location.assign(
          `/user-settings?msg=You must have an active Billing Profile to submit a credit application.&type=warning`
        );
      }
    }
    setBillingAccount(location.state.billingAccount);
  }, [user]);

  // This uses the passed in userId to render UI for staff members to verify which user they are acting on behalf of.
  const [getXomertyUserData, { data: xomUserByIdQueryResult }] =
    useLazyQuery(UserByIdQuery);

  useEffect(() => {
    // We only need to query userById if a staff member is accessing the credit application on behalf of a user/partner.
    if (isStaff()) {
      getXomertyUserData({
        variables: {
          id: userID,
        },
      });
    }
  }, [userID]);

  if (isLoading) return <Spinner />;

  return (
    <>
      {billingAccount && (
        <Box css={accountsettings_page}>
          {isStaff() && xomUserByIdQueryResult && (
            <Toast
              isOpen={isStaff()}
              kind={theme.kind.warning}
              hideClose={true}
              css={staff_banner}
            >
              <Text kind="body" margin="auto">
                You are acting on behalf of entity:{' '}
                <Text kind="body-title" color={theme.colors.blues[100]}>
                  {billingAccount.id}{' '}
                </Text>
                <Text kind="body-title">{billingAccount.name}</Text> |{' '}
                <Text kind="body-title" color={theme.colors.blues[100]}>
                  {userID}{' '}
                </Text>
                {xomUserByIdQueryResult.userById?.firstName}{' '}
                {xomUserByIdQueryResult.userById?.lastName}{' '}
                {xomUserByIdQueryResult.userById?.emailAddress}
              </Text>
            </Toast>
          )}
          <Box maxWidth="690px" margin="auto">
            <Box marginBottom="20px">
              <Link
                href={isStaff() ? `/user-settings/${userID}` : '/user-settings'}
                css={css`
                  &:hover {
                    text-decoration: none;
                  }
                `}
              >
                <i
                  className="fa fa-angle-left"
                  color={theme.colors.blues[100]}
                  css={css`
                    margin-right: 4px;
                  `}
                />
                <Text kind="body-sm-title" color={theme.colors.blues[100]}>
                  Return to Account Settings
                </Text>
              </Link>
            </Box>
            <Flex>
              <CreditTermsForm
                userId={userID}
                isStaff={isStaff()}
                billingAccount={billingAccount}
              />
              {/* <InfoPanel /> */}
            </Flex>
          </Box>
        </Box>
      )}
    </>
  );
};

export default CreditTermsApplication;
